import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AnimatedBackground from "../components/AnimatedBackground";
import "../App.css";

const About = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -100px 0px" }
    );

    const elements = document.querySelectorAll(".reveal-on-scroll");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <AnimatedBackground />
      <div className="app">
        <div className="top-header">
          <div className="navbar-wrap">
            <Navbar />
          </div>
        </div>

        <header className="app-header">
          <div className="title-glow"></div>
          <div className="about-hero-heading">
            <h1 className="title about-title">
              Shopping smart means clarity, not choice overload.
            </h1>
          </div>
        </header>

        <main className="main-content">
          <section className="section">
            <div className="section-inner merchant-page">
              <div className="about-body-card reveal-on-scroll">
                <p>
                  Open any category today: beauty, running shoes, supplements, wine, and you're staring at hundreds of near-identical products. Same claims. Same five-star reviews. No real way to tell what's actually right for you.
                </p>
                <p>
                  GenieShop is an AI shopping agent built for exactly that problem. Tell it what you need, in plain language, and it searches across curated multi-brand retailers to surface what actually fits.
                </p>
                <div className="about-coming-soon">
                  <span className="about-coming-soon-badge">Coming Soon</span>
                  <p>GenieShop MCP App — for your favorite AI chatbots.</p>
                </div>
                <p className="about-closer">Search less. Shop smart.</p>
              </div>

              <div className="merchant-section-block">
                <h3 className="merchant-section-title">How to Get Started for Brands</h3>
                <div className="merchant-feature-grid">
                  <div className="merchant-feature-card reveal-on-scroll">
                    <span className="merchant-feature-number">01</span>
                    <h4>Connect via BizNetAI</h4>
                    <p>
                      List your catalog through{" "}
                      <a
                        href="https://biznetai.consumergenie.net/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        BizNetAI
                      </a>
                      's guided onboarding — no new app to build, no dev team required. Your products, pricing, and updates stay fully under your control.
                    </p>
                  </div>
                  <div className="merchant-feature-card reveal-on-scroll">
                    <span className="merchant-feature-number">02</span>
                    <h4>Your catalog goes live in GenieShop</h4>
                    <p>
                      Once connected, your brand gets its own dedicated GenieShop channel, scoped to just your products.
                    </p>
                  </div>
                  <div className="merchant-feature-card reveal-on-scroll">
                    <span className="merchant-feature-number">03</span>
                    <h4>Genie sells for you</h4>
                    <p>
                      Shoppers ask Genie in plain language, and Genie ranks, compares, and summarizes your products with real specs and sources.
                    </p>
                  </div>
                  <div className="merchant-feature-card reveal-on-scroll">
                    <span className="merchant-feature-number">04</span>
                    <h4>Checkout without leaving the chat</h4>
                    <p>
                      Shoppers add to cart and pay with Stripe right inside the conversation — you get a completed sale without building your own cart or checkout flow.
                    </p>
                  </div>
                </div>
              </div>

              <div className="merchant-section-block">
                <h3 className="merchant-section-title">Benefits for Brands</h3>
                <ul className="merchant-benefits-list">
                  <li>Customer Convenience</li>
                  <li>Transparency &amp; Trust</li>
                  <li>Easy Integration</li>
                  <li>Collaborative Growth</li>
                </ul>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default About;
